import { useCallback, useRef } from "react";

/**
 * Hook to track chart container via ResizeObserver.
 * Returns a callback ref to attach to the chart wrapper div.
 */
export function useChartResize() {
  const observerRef = useRef<ResizeObserver | null>(null);

  const setChartWrapperNode = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (node) {
      observerRef.current = new ResizeObserver(() => {
        // Trigger re-render via ResizeObserver (noop — Recharts handles responsive sizing internally)
      });
      observerRef.current.observe(node);
    }
  }, []);

  return { setChartWrapperNode };
}
